import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { ProfileService } from '../../../services/ProfileService';
import { catchError } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ToasterService } from 'angular2-toaster';
import { IAsset } from '../../../models/IAsset';
import { FormBuilder } from '@angular/forms';
import { InvokeFunctionExpr } from '@angular/compiler';

@Component({
    selector: 'app-user-documents',
    templateUrl: './user-documents.component.html'
})

export class AppUserDocumentsComponent implements OnInit {
    constructor(private profileService: ProfileService,
        private toastr: ToasterService,
        private fb: FormBuilder) { }

    @ViewChild('fileInput') fileInput: ElementRef;
    refreshAssetsSubject = new Subject<void>();
    userAssets$: Observable<IAsset>;
    uploadFilesForm = this.fb.group({});
    @Input() identity = '';



    onSelectFileClick() {
        this.fileInput.nativeElement.click();
    }

    fileChanged(event) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];

            const formData = new FormData();
            formData.append('uploadFile', file, file.name);

            this.profileService.uploadDocument(formData, this.identity)
                .pipe(catchError((er) => this.handleError(er)))
                .subscribe(() => this.refreshAssetsSubject.next());
        }
    }

    removeAsset(assetId) {
        this.profileService.removeUserAsset(assetId, this.identity)
            .subscribe(() => this.refreshAssetsSubject.next());
    }

    ngOnInit() {
        this.userAssets$ = this.refreshAssetsSubject
            .asObservable()
            .pipe(catchError(error => this.handleError(error)))
            .switchMap(() => this.profileService.getUserAssets(this.identity));

        setTimeout(() => {
            this.refreshAssetsSubject.next();
        });

    }

    handleError(ex: HttpErrorResponse): any {
        this.toastr.pop('error', ex.name, ex.error.exceptionMessage || ex.error);
    }

}
